import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import { error, input } from "./styles.module.scss"

const TextBox = ({ placeholder, value, onChange, hasErrors, label }) => (
  <input
    type="text"
    className={classNames(input, { [error]: hasErrors })}
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    aria-label={label}
  />
)

TextBox.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  hasErrors: PropTypes.bool,
}

TextBox.defaultProps = {
  placeholder: undefined,
  hasErrors: false,
}

export default TextBox
